/**
 * As páginas de assunto: uma por vídeo, para quem procura no Google.
 *
 * Um reel some do feed em dois dias. Uma página do mesmo assunto continua
 * respondendo "o que é RAG" por anos — e é nela que a pessoa encontra o
 * formulário da lista. É o que transforma alcance em público.
 *
 * O texto vem da legenda que ele escreveu para o post, que já passou pela
 * regra das duas fontes antes de virar vídeo. Nada aqui é escrito sem isso.
 */

export interface Fonte {
  /** Quem publicou e o quê, como ele citou na legenda. */
  nome: string;
  /** Link direto quando existe. Sem link, a fonte ainda vale: é citável. */
  url?: string;
}

export type Bloco =
  | { tipo: "p"; texto: string }
  | { tipo: "h2"; texto: string }
  | { tipo: "ul"; itens: readonly string[] };

export interface Assunto {
  /** O mesmo slug do vídeo, que já nomeia a capa e a prévia em public/videos. */
  slug: string;
  /** O que a pessoa digita na busca. É o título da aba e o H1. */
  titulo: string;
  /** Uma linha, para a descrição do resultado de busca. */
  resumo: string;
  /** A resposta em uma ou duas frases, antes de qualquer explicação. */
  abertura: string;
  corpo: readonly Bloco[];
  fontes: readonly Fonte[];
  /** Quando o conteúdo foi conferido pela última vez (ISO, só a data). */
  conferidoEm: string;
  /** Ressalva que precisa aparecer junto das fontes, quando houver. */
  ressalva?: string;
}

/**
 * O portão: página sem fonte não vai ao ar.
 *
 * O site inteiro se apresenta como "explicada com fonte". Uma página sem a
 * lista de fontes contradiz isso na hora, então em vez de confiar na
 * disciplina de quem edita, o código simplesmente não publica. Um assunto
 * com `fontes: []` fica no arquivo, fora das rotas e fora do sitemap, até
 * alguém preencher.
 */
export function publicavel(a: Assunto): boolean {
  return a.fontes.length > 0 && a.corpo.length > 0;
}
